(ns teamoesterreich.text.get-text
  (:require
    [teamoesterreich.config :as config]
    ))


(defn txt [module key]
  (or (get-in config/TEXT_MAP [module key]) (str "??" module "/" key)))


(defn transl [key]
  (let [lang (or js/navigator.language js/navigator.userLanguage "de")
        lang (cond
               ;(re-find lang #"^en.*") "en"
               ;(re-find lang #"^de.*") "de"
               (= lang "en") "en"
               (= lang "en-US") "en"
               (= lang "en-GB") "en"

               (= lang "de") "de"
               (= lang "de-DE") "de"
               (= lang "de-AT") "de"
               :else "de")
        res (or (get-in config/TRANSLATION_MAP [lang key])
                (get-in config/TEXT_MAP ["de" key])
                (str "??" lang "/" key))

        ]
    (str res)))



;(in-ns 'teamoesterreich.text.get-text)






